import { SUPPORT_EMAIL } from "helpers/constants"
import "./style.scss"

function NoData() {
  return <div className="components_no-data d-flex flex-md-row flex-column">
    <div className="d-flex flex-md-row flex-column">
      <div className="mr-auto">
        <h1>Ugh!</h1>
        <h2>Sorry for the inconvenience &hellip;</h2>
        <p className="error-code">Error code: 400</p>
        <p>We could not locate the data you were looking for.</p>
        <p>If you need immediate assistance, please use the help widget at the bottom-right or send an email to <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a> to get in touch with us.</p>
      </div>
      <div className="pt-5">
        <img src="https://s3.amazonaws.com/pi-ompnt-nodejs/penguin4.png" width="80%" />
      </div>
    </div>
  </div>
}

export default NoData
